export default function ProductDetailSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="container mx-auto pt-8 px-4 lg:px-6 xl:px-8 hidden sm:flex sm:justify-between sm:items-center">
        <div className="h-10 w-28 bg-greyscale-separator rounded-sm" />
        <div className="flex gap-2">
          <div className="h-5 w-12 bg-greyscale-separator rounded-sm" />
          <div className="h-5 w-12 bg-greyscale-separator rounded-sm" />
          <div className="h-5 w-12 bg-greyscale-separator rounded-sm" />
          <div className="h-5 w-12 bg-greyscale-separator rounded-sm" />
        </div>
      </div>

      <div className="container mx-auto py-4 md:py-8 grid grid-cols-1 md:grid-cols-5 gap-8 px-4 lg:px-6 xl:px-8">
        <div className="md:col-span-3 md:space-y-8">
          <div className="bg-greyscale-separator h-[300px] md:h-[550px]" />
          <div className="block md:hidden py-6 md:py-0 space-y-2">
            <div className="h-10 bg-greyscale-separator rounded-sm" />
            <div className="h-10 bg-greyscale-separator rounded-sm" />
            <div className="w-3/5 bg-greyscale-separator rounded-sm" />
            <div className="h-5 w-4/5 bg-greyscale-separator rounded-sm" />
            <div className="h-5 w-3/5 bg-greyscale-separator rounded-sm" />
            <div className="h-5 w-2/5 bg-greyscale-separator rounded-sm" />
          </div>
          <div className="space-y-2">
            <div className="h-6 bg-greyscale-separator rounded-sm" />
            <div className="h-5 w-4/5 bg-greyscale-separator rounded-sm" />
            <div className="h-5 w-3/5 bg-greyscale-separator rounded-sm" />
            <div className="h-5 w-2/5 bg-greyscale-separator rounded-sm" />
          </div>
        </div>
        <div className="hidden md:block md:col-span-2">
          <div className="space-y-2">
            <div className="h-10 bg-greyscale-separator rounded-sm" />
            <div className="h-10 w-3/5 bg-greyscale-separator rounded-sm" />
            <div className="h-6 w-3/5 bg-greyscale-separator rounded-sm" />
            <div className="h-6 w-2/5 bg-greyscale-separator rounded-sm" />
          </div>
        </div>
      </div>
    </div>
  );
}
